import type { DomWidgetFactoryService, WidgetFactory } from '@examdojo/core/widget';
import { FunctionMachineWidget } from './function-machine/function-machine.widget';
import { FUNCTION_MACHINE_PRESETS } from './function-machine/presets';
import { FunctionTestWidget, FUNCTION_TEST_PRESETS } from './function-test';
import { GeometryPadWidget, GEOMETRYPAD_PRESETS } from './geometrypad';
import { GraphpadWidget, GRAPHPAD_PRESETS } from './functions/graphpad';
import { UnitCircleWidget, UNIT_CIRCLE_PRESETS } from './unit-circle';

/**
 * Register JSXGraph-based widgets with the JSXGraph factory.
 */
export function registerJsxgraphWidgets(factory: WidgetFactory): void {
  factory.register('graphpad', GraphpadWidget);
  factory.register('geometrypad', GeometryPadWidget);
  factory.register('function-test', FunctionTestWidget);
  factory.register('unit-circle', UnitCircleWidget);

  for (const preset of GRAPHPAD_PRESETS) {
    factory.registerPreset(preset);
  }

  for (const preset of GEOMETRYPAD_PRESETS) {
    factory.registerPreset(preset);
  }

  for (const preset of FUNCTION_TEST_PRESETS) {
    factory.registerPreset(preset);
  }

  for (const preset of UNIT_CIRCLE_PRESETS) {
    factory.registerPreset(preset);
  }
}

/**
 * Register DOM-based widgets with the DOM factory.
 */
export function registerDomWidgets(factory: DomWidgetFactoryService): void {
  factory.register('function-machine', FunctionMachineWidget);

  for (const preset of FUNCTION_MACHINE_PRESETS) {
    factory.registerPreset(preset);
  }
}
